import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchGptResponse, fetchMetricToTargetResponse } from './inferenceApi';
import { v4 as uuidv4 } from 'uuid';

export const useGptResponses = () => {
    const dispatch = useDispatch();
    const [responseId, setResponseId] = useState('');
    const [loadingResponse, setLoadingResponse] = useState(false);
    const [loadingInference, setLoadingInference] = useState(false);  // Additional loading state for portfolio inference


    const handleSubmission = useCallback((thunk, kwargs, afterSuccess)=>{
        setLoadingResponse(true);
        const promptId = uuidv4();
        dispatch(thunk({...kwargs, id: promptId}))
            .then(()=>{
                setLoadingResponse(false);
                afterSuccess?.();
            })
            .catch(()=>{
                setLoadingResponse(false);
            });
        setResponseId(promptId);
        return promptId;
    }, [dispatch]);

    const submitPrompt = useCallback((promptData, srcLocation, promptHeadKey, afterSuccess) => {
        const kwargs = { promptData, srcLocation, promptHeadKey };
        return handleSubmission(fetchGptResponse, kwargs, afterSuccess);
    }, [dispatch]);

    const submitMetricToTarget = useCallback((metricName, currentValue, targetValue, tickerWeights, afterSuccess) => {
        const kwargs = { metricName, currentValue, targetValue };
        return handleSubmission(fetchMetricToTargetResponse, kwargs, afterSuccess);
    })


    return {
        responseId,
        submitPrompt,
        submitMetricToTarget,
        loadingResponse,
        loadingInference  // Loading state for portfolio inference
    };
};
